
<div>
  @for (owner of this.owners; track owner) {
    <span style='margin-right:5px;'>
      {{owner}}<span class='k-icon k-i-close' (click)='this.deleteOwner(owner)'></span>
    </span>
  }
</div>

<!-- <div style='margin-top:10px;'>
<input kendoTextBox (keyup.enter)='this.addOwner()'/><span class='k-icon k-i-plus' (click)='this.addOwner()'>x</span>
</div> -->
<!-- <div style='margin-top:10px;'>
<button kendoButton (click)="saveTags()" themeColor="primary" [disabled]='this.isSaving'>Save Tags</button>
</div> -->
